import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./tutorial/tutorial.css"; // Import tutorial CSS
import App from "./App.js";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
